import { React, useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';

import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';

export default function WeeklyColumn(props) {
  const { 
    isLoading,
    height, 
    today, 
    standardDate, 
    onClickWeeklyDeleteButton 
  } = props;

  const [dateList, setDateList] = useState([today]);
  const [hoverIndex, setHoverIndex] = useState(-1);

  useEffect(() => {
    let newDateList = [];

    for (let i = 0; i < 7; i++) {
      newDateList.push(today.clone().add(i, 'day'));
    }

    setDateList(newDateList);
  }, [today])

  // 몇주차인지 계산하기 //
  function getWeekNumber(date) {
    const standard = new Date(date);

    const currentDate = standard.getDate();
    const startOfMonth = new Date(standard.setDate(1));
    const weekDay = startOfMonth.getDay();

    return parseInt(((weekDay - 1) + currentDate) / 7) + 1;
  }

  // 날짜 텍스트 색상 결정 //
  function decideFontColor(data, index) {
    if (hoverIndex === index) return '#FFFFFF';
    else if (data.format('YYYY.MM.DD') === moment().format('YYYY.MM.DD')) return '#FF8B48';
    else return '#595959';
  }

  // 호버링 //
  function onMouseOver(index) {
    if (isLoading) return;

    setHoverIndex(index);
  }

  // 호버링 //
  function onMouseLeave(index) {
    if (isLoading) return;
    
    if (hoverIndex === index) setHoverIndex(-1);
  }

  return (
    <TopLevelWrapper>
      <WeekBox style={{ marginRight: '2px' }}>
        <Text fontFmaily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='default'>{getWeekNumber(standardDate) + '주차'}</Text>
      </WeekBox>
      {/* {
        dateList.map((data, index) => (
          index === 0 ?
            <FirstColumnWrapper key={index}>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={14} color={data.format('YYYY.MM.DD') === moment().format('YYYY.MM.DD') ? `#FF8B48` : `#595959`} hover='default' >{data.format('DD일 (dd)')}</Text>
            </FirstColumnWrapper>
            :
            <ColumnWrapper key={index}>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={14} color={data.format('YYYY.MM.DD') === moment().format('YYYY.MM.DD') ? `#FF8B48` : `#595959`} hover='default' >{data.format('DD일 (dd)')}</Text>
            </ColumnWrapper>
        ))
      } */}
      <TotalColumnBoxWrapper>
      {
        dateList.map((data, index) => (
          <ColumnBoxWrapper 
            key={'DateColumn-' + index}
            onMouseOver={() => onMouseOver(index)}
            onMouseLeave={() => onMouseLeave(index)}>
            <WeekAllDeleteBackground
              isHover={hoverIndex === index}
              height={height}/>
            <ColumnBox>
              <Text 
                style={hoverIndex === index ? {marginRight: '0px'} : {marginRight: '-28px'}}
                fontFmaily='NotoSansKR-Bold' 
                fontSize={14} 
                color={decideFontColor(data, index)} 
                hover='pointer'>{data.format('DD일 (dd)')}</Text>
                <DeleteButton 
                  isHover={hoverIndex === index} 
                  onClick={() => onClickWeeklyDeleteButton(data, index)}>
                  <DeleteIcon src={WhiteTrashIcon}/>
                </DeleteButton>
            </ColumnBox>
          </ColumnBoxWrapper>
        ))
      }
      </TotalColumnBoxWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  // margin-bottom: 28px;

  // width: 974px;
  width: 994px;

  gap: 10px;

  z-index: 5;
`;

const WeekBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
  
  width: 70px;
  height: 23px;

  border-radius: 4px;
  background-color: #FF8B48;
`;

const FirstColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding-left: 10px;

  width: 83px;
`;

const TotalColumnBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: calc(100% - 80px);

  gap: 6px;
`;

const ColumnBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;

  padding: 28px 0px;
  
  width: 123px;

  &:hover {
    cursor: pointer;
  }
`;

const ColumnBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;

  gap: 10px;

  z-index: 2;
  
  &:hover {
    cursor: pointer;
  }
`;

const WeekAllDeleteBackground = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: -12px;

  width: 139px;
  height: ${props => props.height}px;

  border-radius: 8px;
  background: linear-gradient(#FF7575, #FFF0F0);

  z-index: 1;

  opacity: ${props => props.isHover ? 1 : 0};

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  opacity: ${props => props.isHover ? 1 : 0};

  &:hover {
    cursor: pointer;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 18px;
  height: 18px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;